import { jsx as v } from "react/jsx-runtime";
import { getCSSValue as y } from "../../utils/get-css-value.js";
import x from "clsx";
import { Slot as w } from "@radix-ui/react-slot";
import { forwardRef as C } from "react";
import '../../assets/background.css';const r = {
  "background--inline": "_background--inline_ghprg_1",
  "background--primary": "_background--primary_ghprg_5",
  "background--secondary": "_background--secondary_ghprg_10",
  "background--tertiary": "_background--tertiary_ghprg_15",
  "background--destructive": "_background--destructive_ghprg_20",
  "background--warning": "_background--warning_ghprg_25",
  "background--info": "_background--info_ghprg_30",
  "background--success": "_background--success_ghprg_35",
  "background--graph": "_background--graph_ghprg_40",
  "background--badge-highlight": "_background--badge-highlight_ghprg_45",
  "background--badge-feature": "_background--badge-feature_ghprg_50",
  "background--badge-info": "_background--badge-info_ghprg_55",
  "background--badge-permission": "_background--badge-permission_ghprg_60",
  "background--badge-offer": "_background--badge-offer_ghprg_65",
  "background--badge-sale": "_background--badge-sale_ghprg_70",
  "background--gradient-alpha": "_background--gradient-alpha_ghprg_75",
  "background--gradient-alpha-180": "_background--gradient-alpha-180_ghprg_80",
  "background--gradient-bravo": "_background--gradient-bravo_ghprg_85",
  "background--gradient-charlie": "_background--gradient-charlie_ghprg_90",
  "background--gradient-volt": "_background--gradient-volt_ghprg_95",
  "background--gradient-volt-reverse": "_background--gradient-volt-reverse_ghprg_100",
  "background--gradient-volt-hdr": "_background--gradient-volt-hdr_ghprg_105",
  "background--gradient-volt-hdr-reverse": "_background--gradient-volt-hdr-reverse_ghprg_110",
  "background--inverted": "_background--inverted_ghprg_115",
  "background--transparent": "_background--transparent_ghprg_120",
  "background--relative": "_background--relative_ghprg_125",
  "background--blur-xs": "_background--blur-xs_ghprg_129",
  "background--blur-sm": "_background--blur-sm_ghprg_133",
  "background--blur-md": "_background--blur-md_ghprg_137",
  "background--blur-lg": "_background--blur-lg_ghprg_141",
  "background--blur-xl": "_background--blur-xl_ghprg_145",
  "background--absolute": "_background--absolute_ghprg_154",
  "background--fixed": "_background--fixed_ghprg_159",
  "background--sticky": "_background--sticky_ghprg_164",
  "background--fill-y": "_background--fill-y_ghprg_174",
  "background--fill-x": "_background--fill-x_ghprg_183",
  "background--rotation": "_background--rotation_ghprg_192"
}, N = C(
  ({
    as: b = "div",
    asChild: c,
    className: u = "",
    variant: g,
    absolute: k,
    relative: _,
    fixed: t,
    sticky: i,
    fillY: d,
    fillX: a,
    style: l = {},
    inline: h,
    inset: e,
    rotation: n,
    blur: o,
    ...s
  }, p) => {
    const f = d != null && d >= 0 && d <= 100, m = a != null && a >= 0 && a <= 100;
    return /* @__PURE__ */ v(
      c ? w : b,
      {
        className: x(
          {
            [r["background--inline"]]: !!h,
            [r["background--primary"]]: g === "primary",
            [r["background--secondary"]]: g === "secondary",
            [r["background--tertiary"]]: g === "tertiary",
            [r["background--destructive"]]: g === "destructive",
            [r["background--warning"]]: g === "warning",
            [r["background--info"]]: g === "info",
            [r["background--success"]]: g === "success",
            [r["background--graph"]]: g === "graph",
            [r["background--inverted"]]: g === "inverted",
            [r["background--transparent"]]: g === "transparent",
            [r["background--badge-highlight"]]: g === "badge-highlight",
            [r["background--badge-feature"]]: g === "badge-feature",
            [r["background--badge-info"]]: g === "badge-info",
            [r["background--badge-permission"]]: g === "badge-permission",
            [r["background--badge-offer"]]: g === "badge-offer",
            [r["background--badge-sale"]]: g === "badge-sale",
            [r["background--gradient-alpha"]]: g === "gradient-alpha",
            [r["background--gradient-alpha-180"]]: g === "gradient-alpha-180",
            [r["background--gradient-bravo"]]: g === "gradient-bravo",
            [r["background--gradient-charlie"]]: g === "gradient-charlie",
            [r["background--gradient-volt"]]: g === "gradient-volt",
            [r["background--gradient-volt-reverse"]]: g === "gradient-volt-reverse",
            [r["background--gradient-volt-hdr"]]: g === "gradient-volt-hdr",
            [r["background--gradient-volt-hdr-reverse"]]: g === "gradient-volt-hdr-reverse",
            [r["background--relative"]]: !!_,
            [r["background--absolute"]]: !!k,
            [r["background--fixed"]]: !!t,
            [r["background--sticky"]]: !!i,
            [r["background--rotation"]]: !!n,
            [r["background--blur-xs"]]: o === "xs",
            [r["background--blur-sm"]]: o === "sm",
            [r["background--blur-md"]]: o === "md",
            [r["background--blur-lg"]]: o === "lg",
            [r["background--blur-xl"]]: o === "xl",
            [r["background--fill-y"]]: f,
            [r["background--fill-x"]]: m
          },
          u
        ),
        style: {
          "--fill-y": d ? `${d}%` : void 0,
          "--fill-x": a ? `${a}%` : void 0,
          "--inset": e ? y(e, "inset") : void 0,
          "--rotation": n ? `${n}deg` : void 0,
          ...l
        },
        ref: p,
        ...s
      }
    );
  }
);
export {
  N as Background
};
